import { render, staticRenderFns } from "./ApplicationsPage.vue?vue&type=template&id=ced3d532&scoped=true"
import script from "./ApplicationsPage.vue?vue&type=script&lang=js"
export * from "./ApplicationsPage.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsPage.vue?vue&type=style&index=0&id=ced3d532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced3d532",
  null
  
)

export default component.exports